<!-- 
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
-->

<template>
    <v-dialog v-model="dialog" persistent width="1000px" :fullscreen="$vuetify.breakpoint.xsOnly">
        <v-form ref="form" v-on:submit.prevent="addProj" v-model="valid" lazy-validation>
            <v-card>
                <v-card-title class="py-6">
                    <div class="text-h4">{{ language.t('SiteCalibration.addSiteCalibration') }}</div>
                </v-card-title>
                <v-card-subtitle>
                    {{ language.t('SiteCalibration.supportedFiles') }}
                </v-card-subtitle>
                <v-alert v-if="error" dense border="left" type="warning">{{ error }}</v-alert>

                <v-card-text class="py-6" v-if="!manualSiteCalibration">
                    {{ completeProjString }}
                    <br>
                    <v-file-input v-model="siteCalibrationFile"
                        :placeholder="language.t('SiteCalibration.siteCalibrationFile')"
                        :label="language.t('SiteCalibration.siteCalibrationFile')" prepend-icon="mdi-paperclip"
                        accept=".dc" :rules="fileSupported">
                    </v-file-input>
                    <v-text-field v-model="name" :label="language.t('SiteCalibration.name')" required
                        dense></v-text-field>
                    <!-- <v-checkbox v-model="manualSiteCalibration" :label="'testtesttest'" dense></v-checkbox> -->

                </v-card-text>



                <!-- <SiteCalibrationEdit v-model=  class="py-6" v-if="manualSiteCalibration" /> -->
                <!-- <v-checkbox v-if="manualSiteCalibration" v-model="manualSiteCalibration" :label="'testtesttest'"
                    dense></v-checkbox> -->

                <v-card-actions class="card-actions">
                    <v-btn color="success" x-large type="submit" :disabled="completeProjString == ''">
                        <v-icon>mdi-check</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="$emit('close');"><v-icon>mdi-close</v-icon>{{
                        language.t('App.close') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script>
import SiteCalibrationEdit from "./SiteCalibrationEdit.vue"

export default {
    components: {
        SiteCalibrationEdit
    },
    props: { projectId: null },
    data() {
        return {
            siteCalibrationFile: null,
            dialog: true,
            loading: false,
            parsedsiteCalibrationFile: null,
            projectionParameters: {
                proj: null,
                lat_0: null,
                lon_0: null,
                k_0: null,
                x_0: null,
                y_0: null,
                a: null,
                rf: null,
            },
            datumParameters: {
                datum: null,
                rotn_x: null,
                rotn_y: null,
                rotn_z: null,
                trans_x: null,
                trans_y: null,
                trans_z: null,
                scale: null
            },
            tykerParameters: {
                tyker_x: null,
                tyker_px: null,
                tyker_y: null,
                tyker_py: null,
                tyker_s: null,
                tyker_rz: null, // value is in degrees, transform to radials.
            },
            hasTykerParameters: false,
            completeProjString: "",
            name: "",
            valid: false,
            fileSupported: [
                v => (!v || v.name.match(/\.[0-9a-z]+$/i)[0] == ".dc") || this.language.t('SiteCalibration.supportedFiles'),
                v => (!v || !this.error) || this.language.t('SiteCalibration.validUnits')
            ],
            manualSiteCalibration: false,
            angleUnit: 180,
            error: null,
        };
    },
    mounted: function () {
    },
    computed: {},
    watch: {
        siteCalibrationFile(val, old) {
            if (val && val.name.toLowerCase().match(/\.[0-9a-z]+$/i)[0] == ".dc") this.parseFile();
            else {
                this.projectionParameters = {
                    proj: null,
                    lat_0: null,
                    lon_0: null,
                    k_0: null,
                    x_0: null,
                    y_0: null,
                    a: null,
                    rf: null,
                }
                this.tykerParameters = {
                    tyker_x: null,
                    tyker_px: null,
                    tyker_y: null,
                    tyker_py: null,
                    tyker_s: null,
                    tyker_rz: null,
                }
                this.datumParameters = {
                    datum: null,
                    trans_x: null,
                    trans_y: null,
                    trans_z: null,
                    rotn_x: null,
                    rotn_y: null,
                    rotn_z: null,
                    scale: null
                }
                this.error = null
                this.hasTykerParameters = false
                this.hasDatumParameters = false
                this.completeProjString = ""
            }
        }
    },
    methods: {
        parseFile() {
            function parseValue(values) {
                const str = values.splice(0, 16).join("").trim();
                return str === "" ? 0 : parseFloat(str);
            }

            this.loading = true;
            var siteCalibrationFileReader = new FileReader();
            siteCalibrationFileReader.onload = function (e) {
                var contents = e.target.result;

                this.parsedsiteCalibrationFile = contents;
                this.loading = false;
                var lines = this.parsedsiteCalibrationFile.split("\r\n");

                // index 5 till 9 are used for projection
                lines.forEach((line, index) => {
                    var [f, s] = line
                    switch (f + s) {
                        //case 00 heeft unit waardes. eerste is radian/degree. 2de is meter/feet 
                        //00EDSC V10-70       0   28-May-24 12:52 113111
                        //00EDSC V10-70       0   28-May-24 12:52 213111
                        case "00":
                            let units = line.slice(-6);
                            var [angleUnit, distUnit, pressUnit, tempUnit, coordPrompt, anglesDirn] = units

                            console.log(angleUnit)

                            var angleUnitError = null;
                            switch (angleUnit) {
                                case "1": // degrees
                                    this.angleUnit = 180
                                    break;
                                case "2": // gons
                                    this.angleUnit = 200
                                    break;
                                default:
                                    console.error("UNKNOWN ANGLE UNIT");
                                    angleUnitError = this.language.t('SiteCalibration.angleUnitError');
                                    break;
                            }

                            console.log(distUnit)
                            var distUnitError = null;
                            switch (distUnit) {
                                case "1": // meters
                                    console.log("NO ERROR")
                                    break;
                                default:
                                    console.error("DISTANCE UNIT IS NOT METERS");
                                    // move to the html section using the key so it gets translated even after parsing
                                    distUnitError = this.language.t('SiteCalibration.distanceUnitError');
                                    break;
                            }

                            if (angleUnitError || distUnitError) {
                                this.error = angleUnitError ? angleUnitError : distUnitError
                                this.valid = false
                            } else {
                                this.error = null;
                            }
                            break;
                        case "64": // 
                            //split 5 //split 16 * 7
                            //1 is origin lat  //2 is origin long //4 is origin north  
                            //5 is origin east  //7 is scale factor
                            var [, , , , projection, ...values] = line
                            console.log(projection)
                            /* 
                            projections 

                            1 No Projection                             (?)
                            2 Plane                                     (?)
                            3 Transverse Mercator                       (+proj=tmerc)
                            4 Mercator                                  (+proj=merc)
                            5 Lambert Conformal Conic 1 Parallel        ?(+proj=lcc)
                            6 Lambert Conformal Conic 2 Parallel        ?(+proj=lcc)
                            7 New Zealand Map Grid                      (+proj=nzmg)
                            8 RSO                                       (?)
                            9 Cassini-Soldner                           (+proj=cass)
                            : Oblique Stereographic                     (?)
                            ; RD Stereographic                          (?)
                            < UPS North                                 ?(+proj=ups)
                            = UPS South                                 ?(+proj=ups +south)
                            > Scale Only                                (?)
                            @ Oblique Conformal Cylindrical             (?)
                            B Albers Equal Area Conic                   (?)
                            C Krovak                                    (+proj=krovak)
                            F Hungarian EOV                             (?)
                            G Stereographic Double                      (?)
                            */

                            switch (projection) {
                                case "1":
                                    this.projectionParameters.proj = "+proj=utm"; // +proj=utm
                                    break;
                                case "2":
                                    this.projectionParameters.proj = "+proj=utm"; // +proj=utm
                                    break;
                                case "3":
                                    this.projectionParameters.proj = "+proj=tmerc";
                                    break;
                                case "4":
                                    this.projectionParameters.proj = "+proj=merc";
                                    break;
                                case "5":
                                case "6":
                                    this.projectionParameters.proj = "+proj=lcc";
                                    break;
                                case "7":
                                    this.projectionParameters.proj = "+proj=nzmg";
                                    break;
                                case "8":
                                    this.projectionParameters.proj = "+proj=utm"; // +proj=utm
                                    break;
                                case "9":
                                    this.projectionParameters.proj = "+proj=cass";
                                    break;
                                case ":":
                                    this.projectionParameters.proj = "+proj=utm"; // +proj=utm
                                    break;
                                case ";":
                                    this.projectionParameters.proj = "+proj=utm"; // +proj=utm
                                    break;
                                case "<":
                                    this.projectionParameters.proj = "+proj=ups";
                                    break;
                                case "=":
                                    this.projectionParameters.proj = "+proj=ups +south";
                                    break;
                                case ">":
                                    this.projectionParameters.proj = "+proj=utm"; // +proj=utm
                                    break;
                                case "@":
                                    this.projectionParameters.proj = "+proj=utm"; // +proj=utm
                                    break;
                                case "B":
                                    this.projectionParameters.proj = "+proj=utm"; //+proj=utm
                                    break;
                                case "C":
                                    this.projectionParameters.proj = "+proj=krovak";
                                    break;
                                case "F":
                                    this.projectionParameters.proj = "+proj=utm"; //+proj=utm
                                    break;
                                case "G":
                                    this.projectionParameters.proj = "+proj=utm"; //+proj=utm
                                    break;
                                default:
                                    console.error("unknown proj string");
                                    break;
                            }


                            this.projectionParameters.lat_0 = parseValue(values); //1
                            this.projectionParameters.lon_0 = parseValue(values); //2
                            values.splice(0, 16) //3 
                            this.projectionParameters.y_0 = parseValue(values); //4 
                            this.projectionParameters.x_0 = parseValue(values); //5 
                            values.splice(0, 16) //6 
                            this.projectionParameters.k_0 = parseValue(values); //7 


                            break;
                        case "65": // local raduis // local flattening
                            //split 4 // //split 16 * 2
                            //1 is local radius //  2 is local flattening

                            var [, , , , ...values] = line

                            this.projectionParameters.a = parseValue(values);
                            this.projectionParameters.rf = parseValue(values);
                            break;
                        case "49": //datum parameters
                            //split 5 //split 16 * 9 
                            // first value
                            // if first item is none (1) do nothing
                            // if first item is seven parameter (2) do +towgs84=
                            // if first item is molodensky (3)
                            var [, , , , datum, ...values] = line
                            console.log(datum)
                            switch (Number(datum)) {
                                case 1:
                                    this.datumParameters = {
                                        datum: null,
                                        trans_x: null,
                                        trans_y: null,
                                        trans_z: null,
                                        rotn_x: null,
                                        rotn_y: null,
                                        rotn_z: null,
                                        scale: null
                                    }
                                    break;
                                case 2:
                                    // negative seems to work.
                                    this.datumParameters.datum = "+towgs84="
                                    values.splice(0, 16) // 1
                                    values.splice(0, 16) // 2
                                    this.datumParameters.rotn_x = parseValue(values) // 3
                                    this.datumParameters.rotn_y = parseValue(values) // 4
                                    this.datumParameters.rotn_z = parseValue(values) // 5
                                    this.datumParameters.trans_x = -parseValue(values) // 6
                                    this.datumParameters.trans_y = -parseValue(values) // 7
                                    this.datumParameters.trans_z = -parseValue(values) // 8
                                    this.datumParameters.scale = parseValue(values) // 9

                                    this.hasDatumParameters = true;
                                    break;
                                case 3:
                                    this.datumParameters = {
                                        datum: null,
                                        rotn_x: null,
                                        rotn_y: null,
                                        rotn_z: null,
                                        trans_x: null,
                                        trans_y: null,
                                        trans_z: null,
                                        scale: null
                                    }
                                    break;
                            }


                            break;
                        case "50":
                            //split 4 //split 16 * 6 
                            //1 is origin north  //2 is origin east //3 is trans north //4 is trans east  
                            //5 is rotn about origin  //6 is scale factor
                            var [, , , , ...values] = line
                            this.hasTykerParameters = true

                            this.tykerParameters.tyker_py = parseValue(values); //1
                            this.tykerParameters.tyker_px = parseValue(values); //2
                            this.tykerParameters.tyker_y = parseValue(values); //3
                            this.tykerParameters.tyker_x = parseValue(values); //4
                            this.tykerParameters.tyker_rz = parseValue(values) * (Math.PI / this.angleUnit); //5
                            this.tykerParameters.tyker_s = parseValue(values); //6
                            break;
                        case "81":
                            return; // finished parsing lines
                    }
                });

                var projString = this.projectionParameters.proj +
                    " +lat_0=" + this.projectionParameters.lat_0 +
                    " +lon_0=" + this.projectionParameters.lon_0 +
                    " +k_0=" + this.projectionParameters.k_0 +
                    " +x_0=" + this.projectionParameters.x_0 +
                    " +y_0=" + this.projectionParameters.y_0 +
                    " +a_0=" + this.projectionParameters.a +
                    " +rf_0=" + this.projectionParameters.rf +
                    " +units=m"


                var tykerProjString =
                    "+tyker_rz=" + this.tykerParameters.tyker_rz +
                    " +tyker_s=" + this.tykerParameters.tyker_s +
                    " +tyker_x=" + this.tykerParameters.tyker_x +
                    " +tyker_y=" + this.tykerParameters.tyker_y +
                    " +tyker_px=" + this.tykerParameters.tyker_px +
                    " +tyker_py=" + this.tykerParameters.tyker_py


                var datumString = this.datumParameters.datum +
                    this.datumParameters.trans_x + ',' +
                    this.datumParameters.trans_y + ',' +
                    this.datumParameters.trans_z + ',' +
                    this.datumParameters.rotn_x + ',' +
                    this.datumParameters.rotn_y + ',' +
                    this.datumParameters.rotn_z + ',' +
                    this.datumParameters.scale

                console.log(this.tykerParameters);
                console.log(this.projectionParameters);

                this.completeProjString = projString
                if (this.hasDatumParameters) {
                    this.completeProjString += " " + datumString
                }
                if (this.hasTykerParameters) {
                    this.completeProjString += " " + tykerProjString
                }

                this.$refs.form.validate()

            }.bind(this);

            siteCalibrationFileReader.readAsText(this.siteCalibrationFile);

        },
        addProj() {
            this.$emit("save", this.completeProjString, this.name, this.projectId)
        },
        onClose() {
            this.$emit("close");
        }
    },
};
</script>

<style scoped>
#support {
    max-width: 1000px;
}
</style>